import React from "react";

import EmailAddress from "../../types/core/EmailAddress";

import "./EmailAddressEditor.scss";
import Checkbox from "../inputform/Checkbox";
import Textbox from "../inputform/Textbox";
import Button from "../buttons/Button";
import IconStyles from "../../types/enums/IconStyles";

interface EmailAddressEditorProps {
    value: EmailAddress;
    valid: string;
    onChange?: (address: EmailAddress) => void;
}

class EmailAddressEditor extends React.Component<EmailAddressEditorProps> {
    changed(address: EmailAddress) {
        this.props.onChange && this.props.onChange(address);
    }
    changeEditPrimary(value: boolean) {
        this.changed({
            ...this.props.value,
            primary: value,
        });
    }
    changeEditAddress(value: string) {
        this.changed({
            ...this.props.value,
            address: value,
        });
    }
    changeEditUnsubscribed() {
        this.changed({
            ...this.props.value,
            unsubscribed: !this.props.value.unsubscribed,
        });
    }

    render(): React.ReactNode {
        return (
            <div className="email-editor">
                <Checkbox
                    label="Primary"
                    value={this.props.value?.primary}
                    readonly={this.props.value?.primary}
                    onChange={value =>
                        !this.props.value?.primary &&
                        this.changeEditPrimary(value)
                    }
                />

                <Textbox
                    value={this.props.value?.address}
                    onChange={value => this.changeEditAddress(value)}
                />

                <Button
                    icon="email"
                    iconStyle={
                        !this.props.value.unsubscribed
                            ? IconStyles.Green
                            : IconStyles.Red
                    }
                    inline={true}
                    tooltip={`This email address is ${
                        this.props.value?.unsubscribed ? "un" : ""
                    }subscribed for notifications, click to ${
                        this.props.value.unsubscribed ? "re" : "un"
                    }subscribe`}
                    tooltipPlace="bottom"
                    onClick={this.changeEditUnsubscribed.bind(this)}
                />

                {this.props.value?.primary && this.props.valid !== null && (
                    <i
                        className={`${
                            this.props.valid === "check" ? "green" : ""
                        } ${this.props.valid === "error" ? "red" : ""}${
                            this.props.valid === "autorenew" ? "working" : ""
                        }`}
                        data-tip={
                            this.props.valid === "check"
                                ? "Valid email address"
                                : "Email address in use or invalid"
                        }
                        data-place="bottom">
                        {this.props.valid}
                    </i>
                )}
            </div>
        );
    }
}

export default EmailAddressEditor;
